<div data-cy="iq-summary-modal__page" mat-dialog-title>
    <div class="flex align-center gap-20 pull-left pl-10 sans-regular">
        <span class="iq-badge">
            <img src="../../../../../../assets/png/iq_analysis_white.png" alt="IQ">
        </span>
        <span [style.color]="'#2800d2'" *ngIf="data.type==='stakeholders'">{{ 'iq.summary' | transloco }}</span><span [style.color]="'#2800d2'">{{this.data.stk_name |trunc:20}}</span>
        <span [style.color]="'#2800d2'" *ngIf="data.type==='contexts'">{{ 'iq.analysis' | transloco }}</span>
    </div>
    <button data-cy="iq-summary-modal__close-btn" type="button" class="close pull-right" (click)="close()">
        <span aria-hidden="true">
            <i class="d-text-middle uil uil-multiply unicon-icon"></i>
        </span>
        <span class="sr-only">
            Close
        </span>
    </button>
    <div *ngIf="updatedAt" class="flex align-center update-status gap-10 pull-right pr-18">
        <i data-cy="iq-summary-modal__get-stakeholder-summary" class="uil uil-redo" (click)="getStakeholderSummary(true)" style="cursor: pointer;"></i>
        <span >{{ 'iq.last_updated_at' | transloco }} {{ updatedAt | date:'yyyy-MM-dd HH:mm:ss' }}</span>
    </div>
</div>


<div mat-dialog-content class="dialog-body">
    <mat-divider *ngIf="data.type==='stakeholders'"></mat-divider>
    <div class="px-24" *ngIf="data.type==='stakeholders'">
        <div class="col-xs-12 sans-regular fade-in" [ngStyle]="{'animation-delay': (1.5 * 0.3) + 's'}">
            <!-- <h3>Header 1</h3> -->
            <div style="margin-top: 15px">
                <mat-progress-bar *ngIf="isProcess" mode="buffer"></mat-progress-bar>

                <!-- Summary Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.summary && !isProcess" class="analysis-section">
                    <div class="section-label">
                        <span class="section-icon summary-icon">📝</span>
                        <span class="section-title">{{ 'iq.summary' | transloco }}</span>
                    </div>
                    <div class="section-value">{{ stakeholderAnalysis.summary }}</div>
                </div>

                <!-- Last Contact Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.last_contact && !isProcess" class="analysis-section">
                    <div class="section-label">
                        <span class="section-icon contact-icon">📅</span>
                        <span class="section-title">{{ 'iq.last_contact' | transloco }}</span>
                    </div>
                    <div class="section-value">
                        <div class="contact-date">{{ stakeholderAnalysis.last_contact.date | date:'dd-MM-yyyy' }}</div>
                        <span *ngIf="!stakeholderAnalysis.last_contact.date">({{ 'iq.no_contact_persons_registered' | transloco }})</span>
                        <!-- <div class="contact-note" *ngIf="stakeholderAnalysis.last_contact.users.length === 0">
                            ({{ 'iq.no_contact_persons_registered' | transloco }})
                        </div> -->
                        <div *ngIf="stakeholderAnalysis.last_contact.users.length > 0" class="contact-users">
                            <span *ngFor="let user of stakeholderAnalysis.last_contact.users" class="user-tag">{{ user }}</span>
                        </div>
                    </div>
                </div>

                <!-- Contact Sentiment Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.contact_sentiment && !isProcess" class="analysis-section">
                    <div class="section-label">
                        <span class="section-icon sentiment-icon">😐</span>
                        <span class="section-title">{{ 'iq.sentiment' | transloco }}</span>
                    </div>
                    <div class="section-value sentiment-text">{{ stakeholderAnalysis.contact_sentiment }}</div>
                </div>

                <!-- Urgent Issues Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.urgent_issues && stakeholderAnalysis.urgent_issues.length > 0 && !isProcess" class="analysis-section urgent-section">
                    <div class="section-label">
                        <span class="section-icon urgent-icon">⚠️</span>
                        <span class="section-title">{{ 'iq.urgent_issues' | transloco }}</span>
                    </div>
                    <div class="section-value list-value">
                        <div *ngFor="let issue of stakeholderAnalysis.urgent_issues; let i = index" class="list-item">
                            {{ i + 1 }}. {{ issue }}
                        </div>
                    </div>
                </div>

                <!-- Open Complaints Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.open_complaints && stakeholderAnalysis.open_complaints.length > 0 && !isProcess" class="analysis-section">
                    <div class="section-label">
                        <span class="section-icon complaints-icon">💬</span>
                        <span class="section-title">{{ 'iq.open_complaints' | transloco }}</span>
                    </div>
                    <div class="section-value list-value">
                        <div *ngFor="let complaint of stakeholderAnalysis.open_complaints; let i = index" class="complaint-item">
                            <div class="complaint-text">{{ i + 1 }}. {{ complaint.description }}</div>
                            <div class="complaint-sentiment">
                                <span class="sentiment-arrow">→</span>
                                <span class="sentiment-label">{{ 'iq.sentiment' | transloco }}:</span>
                                <span class="sentiment-value" [ngClass]="'sentiment-' + complaint.sentiment">{{ complaint.sentiment }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Customer Requirement Topics Section -->
                <div *ngIf="stakeholderAnalysis && stakeholderAnalysis.customer_requirement_topics && stakeholderAnalysis.customer_requirement_topics.length > 0 && !isProcess" class="analysis-section">
                    <div class="section-label">
                        <span class="section-icon requirements-icon">✅</span>
                        <span class="section-title">{{ 'iq.customer_requirement_topics' | transloco }}</span>
                    </div>
                    <div class="section-value list-value">
                        <div *ngFor="let topic of stakeholderAnalysis.customer_requirement_topics; let i = index" class="list-item">
                            {{ i + 1 }}. {{ topic }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xs-12 sans-regular px-0" *ngIf="data.type==='contexts'">
        <div class="mx-30 my-30">
            <mat-progress-bar *ngIf="isProcess" mode="buffer"></mat-progress-bar>
        </div>
        <mat-stepper #stepper *ngIf="!showAnalysisSummary && !isProcess" (selectionChange)="onStepChange($event)" [(selectedIndex)]="selectedStepIndex" [ngStyle]="{'--stepper-border-width': progressbarWidth}">
            <ng-template matStepperIcon="edit" let-index="index">
                <span>{{ index + 1 }}</span>
            </ng-template>

            <ng-template matStepperIcon="edit" let-index="index">
                <span>{{ index + 1 }}</span>
            </ng-template>

            <ng-template matStepperIcon="edit" let-index="index">
                <span>{{ index + 1 }}</span>
            </ng-template>
            <!-- 1st step -->
            <mat-step [editable]="true">
                <div>
                    <ng-template matStepLabel><span class="fs-12 sans-regular">{{'iq.project_info'|transloco}}</span></ng-template>
                    <div class="py-30 px-30" *ngIf="showContent[0]">
                        <!-- Questions heading -->
                        <div class="flex align-center gap-20 fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                            <span class="star-badge animate-element disappear-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                            <span class="sans-regular fc-black">{{'iq.analysis_labels.hi' | transloco: { name: globals.user.name } }}</span>
                        </div>
                        <!-- Project type -->
                        <div class="gd-vertical mt-45 gap-20">
                            <div class="flex gap-10 align-center gap-20 fade-in" [ngStyle]="{'animation-delay': (2 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="selectedType && !selectedType.length"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="selectedType && selectedType.length">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.select_type' | transloco}}</span>
                            </div>
                            <div class="fade-in" [ngStyle]="{'animation-delay': (3 * 0.3) + 's'}">
                                <app-generic-multiselect-checkbox data-cy="iq-summary-modal__generic-multiselect-checkbox" placeholder="Project type" name="project_type" [(ngModel)]="selectedType" [multiple]="false">
                                    <app-generic-multiselect-checkbox-option *ngFor="let type of projectTypes" [value]="type">
                                    {{ 'project_type.project_type_'+type.id | transloco }}
                                    </app-generic-multiselect-checkbox-option>
                                </app-generic-multiselect-checkbox>
                            </div>
                        </div>
                        <!-- Project phase -->
                        <div class="gd-vertical mt-10 gap-20">
                            <div class="flex gap-10 align-center gap-20 fade-in" [ngStyle]="{'animation-delay': (4 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="selectedPhase && !selectedPhase.length"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="selectedPhase && selectedPhase.length">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.select_phase' | transloco}}</span>
                            </div>
                            <div class="fade-in" [ngStyle]="{'animation-delay': (5 * 0.3) + 's'}">
                                <app-generic-multiselect-checkbox data-cy="iq-summary-modal__generic-multiselect-checkbox-2" [placeholder]="'Project ' + ('reusable.project_setting.phase' | transloco)" name="project_phase" [(ngModel)]="selectedPhase" [multiple]="false">
                                    <app-generic-multiselect-checkbox-option *ngFor="let phase of projectPhases" [value]="phase">
                                        {{ 'project_phase.project_phase_'+phase.id | transloco }}
                                    </app-generic-multiselect-checkbox-option>
                                </app-generic-multiselect-checkbox>
                            </div>
                        </div>
                        <!-- Project description -->
                        <div class="gd-vertical mt-10 gap-20">
                            <div class="flex align-center gap-20 fade-in" [ngStyle]="{'animation-delay': (6 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="!description || !description.length"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="description && description.length">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.describe_project' | transloco}}</span>
                            </div>
                            <mat-form-field class="full-width fade-in" [ngStyle]="{'animation-delay': (7 * 0.3) + 's'}">
                                <mat-label>Project {{'reusable.project_setting.description' | transloco}}*</mat-label>
                                <input data-cy="iq-summary-modal__description-input" matInput name="description" [(ngModel)]="description"/>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- 2nd step -->
            <mat-step [editable]="true">
                <div>
                    <ng-template matStepLabel><span class="fs-12 sans-regular">Details</span></ng-template>
                    <div class="py-30 px-30" *ngIf="showContent[1]">
                        <!-- Political landscape -->
                        <div class="mt-10">
                            <div class="flex gap-15 align-center fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="interestedInPolitical===null"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="interestedInPolitical!==null">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.interested_in_political' | transloco}}</span>
                            </div>
                            <div class="mt-30 fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <mat-button-toggle-group data-cy="iq-summary-modal__political-toggle" name="politicalToggle" [(ngModel)]="interestedInPolitical" [hideSingleSelectionIndicator]="false" class="fit-content">
                                    <mat-button-toggle [value]="true">{{'iq.analysis_labels.yes' | transloco}}</mat-button-toggle>
                                    <mat-button-toggle [value]="false">{{'iq.analysis_labels.no' | transloco}}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                        <!-- Regulatory Analysis -->
                        <div *ngIf="interestedInPolitical !== null">
                            <div class="flex gap-15 align-center fade-in mt-35" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="includeRegulatoryThemeAnalysis===null"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="includeRegulatoryThemeAnalysis!==null">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.include_regulatory_analysis' | transloco}}</span>
                            </div>
                            <div class="mt-30 fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <mat-button-toggle-group data-cy="iq-summary-modal__regulatory-toggle" name="regulatoryToggle" [(ngModel)]="includeRegulatoryThemeAnalysis" [hideSingleSelectionIndicator]="false" class="fit-content">
                                    <mat-button-toggle [value]="true">{{'iq.analysis_labels.yes' | transloco}}</mat-button-toggle>
                                    <mat-button-toggle [value]="false">{{'iq.analysis_labels.no' | transloco}}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                        <!-- Sociologic Analysis -->
                        <div *ngIf="includeRegulatoryThemeAnalysis !== null">
                            <div class="flex gap-15 align-center fade-in mt-35" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="includeSociologicAnalysis==null"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="includeSociologicAnalysis!==null">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.include_sociologic_analysis' | transloco}}</span>
                            </div>
                            <div class="mt-30 fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <mat-button-toggle-group data-cy="iq-summary-modal__sociologic-toggle" name="sociologicToggle" [(ngModel)]="includeSociologicAnalysis" [hideSingleSelectionIndicator]="false" class="fit-content">
                                    <mat-button-toggle value="true">{{'iq.analysis_labels.yes' | transloco}}</mat-button-toggle>
                                    <mat-button-toggle value="false">{{'iq.analysis_labels.no' | transloco}}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                        <!-- Select Entities -->
                        <div class="gd-vertical mt-35 gap-20" *ngIf="includeSociologicAnalysis !== null">
                            <div class="flex gap-10 align-center fade-in" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <span class="star-badge animate-element" *ngIf="authorities && !authorities.length"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                <span class="tick-badge" *ngIf="authorities && authorities.length">
                                    <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                                    </svg>
                                </span>
                                <span class="sans-regular fc-black">{{'iq.analysis_labels.select_entities' | transloco}}</span>
                            </div>
                            <div class="fade-in mt-15" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}">
                                <app-generic-multiselect-checkbox data-cy="iq-summary-modal__generic-multiselect-checkbox-3" placeholder="{{ 'iq.analysis_labels.amenities' | transloco }}" name="authorities" [(ngModel)]="authorities" [multiple]="true">
                                    <app-generic-multiselect-checkbox-option *ngFor="let type of amenitiesTypes" [value]="type">
                                    {{ 'maps.overpass_Groups.'+type.name | transloco }}
                                    </app-generic-multiselect-checkbox-option>
                                </app-generic-multiselect-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- 3rd step -->
            <mat-step>
                <ng-template matStepLabel><span class="fs-12 sans-regular">{{'iq.analysis_labels.analyse' | transloco}}</span></ng-template>

                <div *ngIf="showContent[2]" class="py-30 px-30 mt-20">
                    <div class="flex gap-20 align-center justify-center fade-in py-30" [class.bg-bugandy]="item.inProgress" [ngStyle]="{'animation-delay': (1 * 0.3) + 's'}" *ngFor="let item of processes">
                        <span class="star-badge animate-element" *ngIf="item.inProgress"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                        <span class="tick-badge" *ngIf="item.finished">
                            <svg class="fat-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z" fill="#cccccc" stroke-width="2"></path>
                            </svg>
                        </span>
                        <span class="sans-regular fc-black">{{item.description + (item.inProgress ? '...':'')}}</span>
                    </div>
                </div>
            </mat-step>
        </mat-stepper>

        <ng-container *ngIf="showAnalysisSummary">
            <app-iq-analysis-summary #analysisSummary [contextAnalysisData]="responseData"></app-iq-analysis-summary>
        </ng-container>
    </div>
</div>

<div mat-dialog-actions align="end" class="px-24" >
    <!-- <button mat-flat-button class="sans-regular" (click)="stepper.next()" [disabled]="!selectedPhase.length || !selectedType.length || !description.length"> -->
    <div class="full-width flex align-center">
        <div class="flex gap-20 pb-15 pt-20 px-8" *ngIf="!allItemsDealtWith()">
            <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span class="sans-regular fc-black text-align-start">{{ 'iq.checked_all' | transloco}} <br> {{ 'iq.now_lets_add_this_to_your_analysis' | transloco }}</span>
        </div>
        <button data-cy="iq-summary-modal__sans-regular-btn" mat-flat-button class="sans-regular ml-auto" (click)="!allItemsDealtWith() && analysisSummary.preparePayloads()" [disabled]="allItemsDealtWith() || analysisSummary.isProcessing()" *ngIf="analysisSummary && analysisSummary.loaded()">
            {{ 'save' | transloco | capitaliz }}
        </button>
    </div>
    <button data-cy="iq-summary-modal__sans-regular-btn-2" mat-flat-button class="sans-regular" *ngIf="data.type!=='contexts' && !isProcess && !showAnalysisSummary" (click)="stakeholderSummaryReport()">
        {{ 'iq.export_pdf' | transloco }}
    </button>
    <button data-cy="iq-summary-modal__sans-regular-btn-3" mat-stroked-button class="sans-regular" (click)="stepper.previous()" *ngIf="selectedStepIndex == 1 && !showAnalysisSummary">
        {{ 'iq.previous_step' | transloco }}
    </button>
    <button data-cy="iq-summary-modal__sans-regular-btn-4" mat-flat-button class="sans-regular" (click)="stepper.next();" [disabled]="!description?.length" *ngIf="!isProcess && selectedStepIndex == 0 && !showAnalysisSummary && data.type !== 'stakeholders'">
        {{ 'iq.next_step' | transloco }}
    </button>
    <button data-cy="iq-summary-modal__sans-regular-btn-5" mat-flat-button class="sans-regular" (click)="stepper.next();" *ngIf="!isProcess && selectedStepIndex == 1 && !showAnalysisSummary && data.type !== 'stakeholders'" [disabled]="isFinalStepDisabled()">
        {{ 'iq.final_step' | transloco }}
    </button>
</div>
